
import { useState, useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface KeyFiltersProps {
  filters: {
    environment: string;
    status: string;
    role: string;
  };
  onFilterChange: (filters: KeyFiltersProps['filters']) => void;
}

const KeyFilters = ({ filters, onFilterChange }: KeyFiltersProps) => {
  // These would come from API in a real app
  const environments = ['all', 'development', 'staging', 'production'];
  const statuses = ['all', 'active', 'revoked', 'expired'];
  const roles = ['all', 'owner', 'admin'];

  const handleFilterChange = (key: keyof KeyFiltersProps['filters'], value: string) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  // Check for soon-to-expire keys
  useEffect(() => {
    // Implementation would check API keys expiration and show notifications
  }, []);

  return (
    <div className="bg-recallio-dark-gray rounded-lg border border-recallio-light-gray/50 p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div>
          <label className="text-sm font-medium mb-1 block">Environment</label>
          <Select
            value={filters.environment}
            onValueChange={(value) => handleFilterChange('environment', value)}
          >
            <SelectTrigger className="w-full bg-recallio-medium-gray border-recallio-light-gray/50">
              <SelectValue placeholder="Select Environment" />
            </SelectTrigger>
            <SelectContent>
              {environments.map((env) => (
                <SelectItem key={env} value={env}>
                  {env === 'all' ? 'All Environments' : env.charAt(0).toUpperCase() + env.slice(1)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="text-sm font-medium mb-1 block">Status</label>
          <Select
            value={filters.status}
            onValueChange={(value) => handleFilterChange('status', value)}
          >
            <SelectTrigger className="w-full bg-recallio-medium-gray border-recallio-light-gray/50">
              <SelectValue placeholder="Select Status" />
            </SelectTrigger>
            <SelectContent>
              {statuses.map((status) => (
                <SelectItem key={status} value={status}>
                  {status === 'all' ? 'All Statuses' : status.charAt(0).toUpperCase() + status.slice(1)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>


        <div>
          <label className="text-sm font-medium mb-1 block">Role</label>
          <Select
            value={filters.role}
            onValueChange={(value) => handleFilterChange('role', value)}
          >
            <SelectTrigger className="w-full bg-recallio-medium-gray border-recallio-light-gray/50">
              <SelectValue placeholder="Select Role" />
            </SelectTrigger>
            <SelectContent>
              {roles.map((role) => (
                <SelectItem key={role} value={role}>
                  {role === 'all' ? 'All Roles' : role.charAt(0).toUpperCase() + role.slice(1)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default KeyFilters;
